import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Twobuttoncta() {
  return;
}